var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSharps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.09 70.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d1c28;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #996875;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.05,
    cy: 35.05,
    r: 35.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.63,24.69c.04-.11.07-.22.07-.33v-3.9c0-.28-.14-.55-.38-.71l-.09-.06c-.25-.17-.58-.19-.85-.05l-2.05,1.04v-7.03c0-.22-.09-.44-.25-.6l-.15-.15c-.16-.16-.37-.25-.6-.25h-1.29c-.26,0-.5.12-.66.32l-.12.15c-.12.15-.19.34-.19.53v8.66l-6.28,2.93v-5.94c0-.3-.16-.57-.41-.73l-.15-.09c-.13-.08-.28-.12-.44-.12h-1.14c-.15,0-.3.04-.44.12l-.15.09c-.25.15-.41.43-.41.73v7.42l-3.11,1.58c-.28.14-.46.44-.46.75v3.84c0,.29.14.55.38.71.24.16.54.18.8.06l2.39-1.05v8.65c-3.58,1.68-3.58,1.79-3.58,2.38v3.93c0,.29.15.56.39.71.25.16.55.17.81.05l2.37-1.11v7.55c0,.26.12.5.32.66l.15.12c.15.12.34.19.53.19h1.14c.19,0,.38-.07.53-.19l.15-.12c.2-.16.32-.4.32-.66v-9.05l6.28-3.04v6.21c0,.22.09.44.25.6l.12.12c.16.16.37.25.6.25h1.29c.19,0,.38-.07.53-.19l.15-.12c.2-.16.32-.4.32-.66v-7.71c3.23-1.78,3.24-1.83,3.34-2.26.02-.07.03-.14.03-.21v-3.75c0-.29-.15-.56-.39-.71-.24-.16-.55-.18-.81-.06l-2.17.98v-8.48c3.1-1.56,3.16-1.7,3.3-2.03ZM38.08,28.37v8.43l-6.28,3.02v-8.54l6.28-2.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharps);
export default __webpack_public_path__ + "static/media/Sharps.87291477c6d4e34c47fb6fc3a518a83a.svg";
export { ForwardRef as ReactComponent };